// extracted by mini-css-extract-plugin
module.exports = {"component":"checkbox-component--110yT"};